import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Paper,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import { storeAuthSession } from "../auth";
import api from "../bootstrapApi";

export default function Login({ onSuccess }) {
  const [email, setEmail] = useState("admin@gada.local");
  const [password, setPassword] = useState("demo");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email.trim() || !password.trim()) {
      setErrorText("L'e-mail et le mot de passe sont obligatoires.");
      setSnackbarOpen(true);
      return;
    }

    try {
      setLoading(true);
      setErrorText("");
      const response = await api.post("/api/login", {
        email,
        password,
      });

      storeAuthSession({
        token: response.data.token,
        name: response.data.user.name,
        role: response.data.user.roleLabel || response.data.user.role,
        roleKey: response.data.user.role,
        email: response.data.user.email,
        userId: response.data.user.id,
      });
      onSuccess();
    } catch (_error) {
      setErrorText("Identifiants invalides ou backend indisponible.");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1.2fr 0.8fr" },
        background:
          "radial-gradient(circle at top left, rgba(95,111,255,0.18), transparent 28%), linear-gradient(180deg, #eef3fb 0%, #e6edf7 100%)",
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          justifyContent: "space-between",
          p: 6,
          color: "#25324b",
        }}
      >
        <Box>
          <Typography variant="overline" sx={{ letterSpacing: "0.24em", color: "#7a859d" }}>
            GADA PLATFORM
          </Typography>
          <Typography variant="h3" sx={{ maxWidth: 620, mt: 2, mb: 2 }}>
            Plateforme moderne de coordination pour le commercial, le PMO, les techniciens et les clients.
          </Typography>
          <Typography variant="body1" sx={{ maxWidth: 560, color: "text.secondary" }}>
            Base de design SmartDoctors, adaptee a la vente de produits, au suivi des commandes,
            a la communication WhatsApp et a l'integration Odoo.
          </Typography>
        </Box>
        <Stack direction="row" spacing={1.25}>
          {["Prospects", "Commandes", "PMO", "WhatsApp"].map((label) => (
            <Paper
              key={label}
              sx={{
                px: 2,
                py: 1.25,
                borderRadius: 999,
                bgcolor: "rgba(255,255,255,0.88)",
                color: "#5f6fff",
                fontWeight: 700,
              }}
            >
              {label}
            </Paper>
          ))}
        </Stack>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: { xs: 3, md: 6 } }}>
        <Paper
          sx={{
            width: "100%",
            maxWidth: 460,
            p: { xs: 3, md: 4 },
            borderRadius: 6,
            boxShadow: "0 24px 60px rgba(31,45,72,0.10)",
          }}
        >
          <Box
            sx={{
              width: 58,
              height: 58,
              borderRadius: 3,
              display: "grid",
              placeItems: "center",
              bgcolor: "primary.main",
              color: "#fff",
              mb: 2,
            }}
          >
            <LockRoundedIcon />
          </Box>
          <Typography variant="h5" sx={{ mb: 0.5 }}>
            Connexion
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Connectez-vous avec un veritable utilisateur backend.
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="E-mail"
              fullWidth
              margin="normal"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <TextField
              label="Mot de passe"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, minHeight: 50 }} disabled={loading}>
              Entrer dans la plateforme
            </Button>
          </Box>
        </Paper>
      </Box>

      <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
        <Alert severity="error" onClose={() => setSnackbarOpen(false)}>
          {errorText || "L'e-mail et le mot de passe sont obligatoires."}
        </Alert>
      </Snackbar>
    </Box>
  );
}
